import styled from 'styled-components'

import { Carat, screenReaderOnly } from '@syconium/little-miss-figgy'

export const Container = styled.div`
  background-color: ${o => o.theme.color.fill.subtle};
  border-radius: ${o => o.theme.spacing(1)};
  font-size: ${o => o.theme.spacing(3)};
  padding: ${o => o.theme.spacing(4)};
`

export const DisclosureCarat = styled(Carat)`
  padding: ${o => o.theme.spacing(1.5)};
  transform: rotate(90deg);
`

export const DisclosureHeader = styled.div`
  align-items: center;
  border-radius: ${o => o.theme.spacing(1)};
  cursor: pointer;
  display: flex;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  justify-content: space-between;
  line-height: ${o => o.theme.spacing(6)};

  &[aria-expanded='true'] {
    ${DisclosureCarat} {
      transform: rotate(-90deg);
    }
  }
`

export const SummaryLabel = styled.div`
  align-items: center;
  display: flex;
`

export const TotalPrice = styled.div``

export const LineItems = styled.div`
  font-weight: ${o => o.theme.typography.font.weight[600]};
`

export const LineItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${o => o.theme.spacing(2)} 0;
`

export const FinalSale = styled.div`
  color: ${o => o.theme.color.text.critical.on.background};
  font-size: ${o => o.theme.spacing(3)};
  font-weight: ${o => o.theme.typography.font.weight[600]};
  padding: ${o => o.theme.spacing(2)} 0;
  text-transform: uppercase;
`

export const Rule = styled.hr`
  border-color: ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  border-top: 0;
  margin: ${o => o.theme.spacing(2)} 0;
`

export const Total = styled.div`
  display: flex;
  font-size: ${o => o.theme.spacing(3)};
  font-weight: ${o => o.theme.typography.font.weight[600]};
  justify-content: space-between;
`

/** Announces the total when it changes; the visible price is inside the disclosure button. */
export const TotalAnnouncement = styled.div`
  ${screenReaderOnly}
`
